export default __webpack_public_path__ + "locales/ro/SmartBanner.json?hash=23f9b2305ded09acaf762240654c49b5";